import {
  OrderReviewAssets,
  OrderReviewLabels,
  paymentModalStore,
} from '../../../view/stores/OrderReviewStore';
import {
  ImageVM,
  OrderReviewContentVM,
} from '../../entities/order-review-content/OrderReviewContentVM.type';

const toIcon = (asset: { src: string; alt: string }): ImageVM => ({
  path: asset.src,
  altText: asset.alt,
});

const DEFAULT_DROP_ICON: ImageVM = toIcon(OrderReviewAssets.dropIcon);
const DEFAULT_CLEAR_ICON: ImageVM = toIcon(OrderReviewAssets.clearInputIcon);
const DEFAULT_BACK_ICON: ImageVM = toIcon(OrderReviewAssets.arrowLeftIcon);
const DEFAULT_CLOSE_ICON: ImageVM = toIcon(OrderReviewAssets.crossIconBlack);
const DEFAULT_GOODS_ICON: ImageVM = toIcon(OrderReviewAssets.goodsType);
const DEFAULT_ETA_ICON: ImageVM = toIcon(OrderReviewAssets.etaClockIcon);
const DEFAULT_PAYMENT_ARROW_ICON: ImageVM = toIcon(
  OrderReviewAssets.accordionArrow,
);
const DEFAULT_PAYMENT_CASH_ICON: ImageVM = toIcon(
  OrderReviewAssets.paymentCash,
);
const DEFAULT_PAYMENT_WALLET_ICON: ImageVM = toIcon(
  OrderReviewAssets.paymentBusinessWallet,
);

const defaultFormFields = {
  pickupAddress: {
    placeholder: OrderReviewLabels.pickupAddressPlaceholder,
    trailingIcon: DEFAULT_CLEAR_ICON,
  },
  dropAddress: {
    placeholder: OrderReviewLabels.dropAddressPlaceholder,
    leadingIcon: DEFAULT_DROP_ICON,
    trailingIcon: DEFAULT_CLEAR_ICON,
  },
  house: {
    placeholder: OrderReviewLabels.editBookingForm.housePlaceholder,
    trailingIcon: DEFAULT_CLEAR_ICON,
  },
  name: {
    placeholder: OrderReviewLabels.editBookingForm.namePlaceholder,
    trailingIcon: DEFAULT_CLEAR_ICON,
  },
  mobile: {
    placeholder: OrderReviewLabels.editBookingForm.mobilePlaceholder,
    trailingIcon: DEFAULT_CLEAR_ICON,
  },
} as const;

export const DEFAULT_ORDER_REVIEW_CONTENT: OrderReviewContentVM = {
  addressDetailsText: OrderReviewLabels.addressDetailsSectionTitle,
  editText: OrderReviewLabels.editText,
  selectVehicleText: OrderReviewLabels.selectVehicleSectionTitle,
  currencySymbol: OrderReviewLabels.currencySymbol,
  unitText: OrderReviewLabels.unitText,
  doneCtaText: OrderReviewLabels.vehicleDetailsModalClose,
  viewBreakupText: OrderReviewLabels.viewBreakupText,
  dropPinIcon: DEFAULT_DROP_ICON,
  mobileHeader: {
    title: OrderReviewLabels.mobileHeaderTitle,
    backIcon: DEFAULT_BACK_ICON,
  },
  goodsType: {
    text: OrderReviewLabels.goodsTypeText,
    defaultSelectText: OrderReviewLabels.goodsTypeDefaultSelectText,
    changeText: OrderReviewLabels.changeText,
    beforeSelectCtaText: OrderReviewLabels.selectGoodsTitle,
    afterSelectCtaText: OrderReviewLabels.bookCtaText,
    icon: DEFAULT_GOODS_ICON,
  },
  etaCapsule: { title: OrderReviewLabels.etaAwayText, icon: DEFAULT_ETA_ICON },
  fareBreakup: {
    title: OrderReviewLabels.fareBreakupTitle,
    tripFare: {
      text: OrderReviewLabels.tripFareText,
      subText: OrderReviewLabels.tripFareSubText,
    },
    netFare: OrderReviewLabels.netFareText,
    amountPayable: OrderReviewLabels.amountPayableText,
  },
  paymentMethod: {
    text: OrderReviewLabels.paymentMethodText,
    subText: OrderReviewLabels.paymentMethodSubText,
    icon: DEFAULT_PAYMENT_ARROW_ICON,
  },
  paymentMethodModal: {
    title: paymentModalStore.title,
    ctaText: paymentModalStore.confirmText,
    cash: {
      title: OrderReviewLabels.cashText,
      icon: DEFAULT_PAYMENT_CASH_ICON,
    },
    porterWallet: {
      title: OrderReviewLabels.porterText,
      subtitle: OrderReviewLabels.businessWalletText,
      icon: DEFAULT_PAYMENT_WALLET_ICON,
    },
  },
  editPickupModal: {
    changeText: OrderReviewLabels.changeText,
    headerText: OrderReviewLabels.editPickupHeaderText,
    ctaText: OrderReviewLabels.confirm,
    addressField: defaultFormFields.pickupAddress,
    houseField: defaultFormFields.house,
    nameField: defaultFormFields.name,
    mobileField: defaultFormFields.mobile,
    closeIcon: DEFAULT_CLOSE_ICON,
  },
  editDropModal: {
    changeText: OrderReviewLabels.changeText,
    headerText: OrderReviewLabels.editDropHeaderText,
    ctaText: OrderReviewLabels.confirm,
    addressField: defaultFormFields.dropAddress,
    houseField: defaultFormFields.house,
    nameField: defaultFormFields.name,
    mobileField: defaultFormFields.mobile,
    fieldIcon: DEFAULT_DROP_ICON,
    closeIcon: DEFAULT_CLOSE_ICON,
  },
};
